export const JOIN = (value: any[]) => {
  return value && value.length > 0 ? value.join(',') : undefined
}
